<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useUserStore } from '@/stores/user'
const store = useUserStore()
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

let email = ref('');
let password = ref('');
let isSubmitting = ref(false);
let validated = ref(false)
let invalid = ref(false)

let failed = ref(false)
let message = ref('')
let deactivationMessage = ref(null)

if (route.query.status == "validated") {
  validated.value = true
}
if (route.query.status == "invalid") {
  invalid.value = true
}

onMounted(() => {
  // Check for deactivation message from localStorage
  const storedMessage = localStorage.getItem("logout_message")
  if (storedMessage) {
    deactivationMessage.value = storedMessage
    // Remove immediately after reading
    localStorage.removeItem("logout_message")
  }

  // Also check route params as fallback
  if (route.params.deactivationMessage) {
    deactivationMessage.value = route.params.deactivationMessage
  }
})

// Clear message when component unmounts to prevent re-display
onUnmounted(() => {
  deactivationMessage.value = ''
  // Defensive cleanup in case removal failed
  localStorage.removeItem("logout_message")
})

async function login() {
    isSubmitting.value = true

    validated.value = false
    invalid.value = false

    let result = await store.login(email.value, password.value)

    isSubmitting.value = false

    if(result.status) {
        // Clear any logout messages after successful login
        deactivationMessage.value = ''
        localStorage.removeItem("logout_message")

        email.value = "",
        password.value = ""

        // Redirect to the original destination or home
        const redirectPath = route.query.redirect || '/home'
        router.push(redirectPath);
    } else {
        failed.value = true
        message.value = result.message
    }
}
</script>

<template>
  <div class="login-container">
    <!--<h3 class="subheader mb-4">Make sense of the internet</h3>-->
      <div class="alert alert-error" v-if="deactivationMessage" role="alert">
        {{ deactivationMessage }}
      </div>
      <div class="alert alert-success" v-else-if="validated" role="alert">
        Account validated!
      </div>
      <div class="alert alert-warning" v-else-if="invalid" role="alert">
        Invalid key - please follow the link in the email
      </div>
      <div class="alert alert-danger" v-else-if="failed" role="alert">
        {{message}}
      </div>
      
      <div class="box bordered p-5">
        <h3 class="mb-4 jura text-center">Welcome back!</h3>
        <!--
        <div class="text-center mb-4">Don't have an account? &nbsp;<router-link to="/signup" class="link" style="color: white !important;">Sign up</router-link> </div>
        -->

        <form action="#" @submit.prevent="login()" class="form-floating mb-4">
            <div class="form-floating mb-3">
                <input type="email" v-model="email" class="form-control dark" id="floatingInput" placeholder="name@example.com">
                <label for="floatingInput">Email address</label>
            </div>
            <div class="form-floating mb-3">
                <input type="password" v-model="password" class="form-control dark" id="floatingPassword" placeholder="Password">
                <label for="floatingPassword">Password</label>
            </div>
            
            <button id="submit-btn" v-if="!isSubmitting" type="submit" class="btn btn-primary">Continue</button>
            <button id="submit-btn" v-else disabled type="submit" class="btn btn-primary">Logging in...</button>
        </form>

        <div class="text-center mb-4"><router-link to="/pw-reset-request" class="link" style="color: inherit;">Forgot password?</router-link></div>
      </div>
  </div>
</template>


<style scoped>
.login-container {
  width: 450px;
}

.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.danger {
    color: var(--color-error-text);
    font-size: 1rem;
}

.alert-error {
  background: rgba(234, 179, 8, 0.15);
  border: 1px solid rgba(234, 179, 8, 0.3);
  color: var(--color-warning);
  padding: 1rem;
  border-radius: var(--radius-md);
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

#submit-btn {
    height: 64px;
    background-color: var(--surface-raised);
    font-size: 1rem;
    outline:none;
    width: 100%;
    box-shadow: none;
    border:none;
    border-radius: var(--radius-md);
}

#submit-btn:hover {
    background-color: #36404F;
}

.link:hover {
  text-decoration: underline;
}
</style>
